$('.filter-tab__title').on('click', function() {
   if (!$(this).hasClass('disabled')) {
     $(this).closest('.filter-tab').toggleClass('filter-tab_active');
   }

});

$('.filter-mob__close-button').on('click', function() {
    $('.filter-mob').removeClass('filter-mob_active');
    $('body').removeClass('menu_open');
});

$('.vacancies__mobile-filter-button').on('click', function() {
    $('.filter-mob').addClass('filter-mob_active');
    $('body').addClass('menu_open');
});
